import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import classnames from "classnames";
import { toast } from "react-toastify";

import * as actions from "../../../../store/actions";
import constants, { getOnboardingPath } from "../../../../constants";

import Button from "../../../../components/formElements/button/Button";
import TextInput from "../../../../components/formElements/input/TextInput";
import Row from "../../../../components/uiElements/grid/Row";
import Card from "../../../../layout/Onboarding/Card";
import DateTimePicker from "../../../../components/formElements/datepicker/DateTimePicker";
import Col from "../../../../components/uiElements/grid/Col";
import FileInput from "../../../../components/formElements/file/FileInput";
import OnboardingIcon from "../../../../components/uiElements/icons/onboardingIcons/OnboardingIcon";
import SelectInput from "../../../../components/formElements/selectInput/SelectInput";
import CardLable from "../../../../components/formElements/label/CardLabel";
import {
  VALIDATE_PATIENT_DOCUMENT_INFO,
  REMOVE_VALIDATIONS,
} from "../../../../store/actions/actionTypes";

const StepTwo = ({
  documents,
  setMedicalRecord,
  savePatientDocuments,
  updatePatientDocuments,
  redirectedPath,
  deleteFileFromS3,
  form,
  history,
  addMedicalRecord,
  removeMedicalRecord,
  validateData,
  removeValidations,
}) => {
  const recordStyles = {
    placeholder: styles => ({
      ...styles,
      color: "#bbc1d0",
    }),
    dropdownIndicator: styles => ({
      ...styles,
      paddingRight: 25,
      display: "inline",
    }),
  };

  const onFileError = error => {
    toast.error(error, {
      position: constants.TOAST_POSITION,
    });
  };

  const myRef = useRef();

  useEffect(() => {
    if (form && form.documents && form.documentsValid) {
      savePatientDocuments("save", () => {
        history.push(getOnboardingPath("/profile-complete"));
      });
    }

    form.documents = false;
    toast.error(form.examination_date, {
      position: constants.TOAST_POSITION,
    });
    toast.error(form.document, {
      position: constants.TOAST_POSITION,
    });

    // eslint-disable-next-line
  }, [form]);
  useEffect(() => {
    removeValidations();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <div
        ref={myRef}
        className={classnames(
          "onboarding-container"
          // documents.dataLoaded && !redirectedPath && "disable"
        )}
      >
        <p className="onboarding-header">
          Medical
          <br /> Records
        </p>
        <Row>
          <Card>
            <Row className="mt-4 mb-5">
              <Col>
                <CardLable
                  condition={null}
                  onclick={() =>
                    form.documents === false
                      ? (validateData(documents),
                        documents.current_medical_record_name &&
                        documents.current_document &&
                        documents.current_record_type &&
                        documents.current_examination_date
                          ? addMedicalRecord()
                          : "")
                      : ""
                  }
                  labelName="Add"
                />
              </Col>
              <Col size={["md-12"]} className="mt-3 mb-n4 ">
                <TextInput
                  error={form.medical_record_name}
                  type="text"
                  label="Medical Record Name"
                  value={documents.current_medical_record_name}
                  onChange={val =>
                    setMedicalRecord({ current_medical_record_name: val })
                  }
                />
              </Col>
              <Col size={["md-12"]} className="mt-n1">
                <SelectInput
                  error={form.record_type}
                  menuPlacement="bottom"
                  options={constants.RECORD_TYPE}
                  placeholder="Record Types"
                  styles={recordStyles}
                  value={documents.current_record_type}
                  onChange={val =>
                    setMedicalRecord({ current_record_type: val })
                  }
                />
              </Col>
              <Col size={["md-12"]} className="mt-4 ">
                <FileInput
                  showPreview
                  buttonClass="w-100 "
                  name="current_document"
                  files={documents.current_document}
                  onChange={files => setMedicalRecord(files)}
                  onError={error => onFileError(error)}
                  onRemove={file =>
                    deleteFileFromS3(file, () =>
                      updatePatientDocuments("update")
                    )
                  }
                />
              </Col>
              <Col size={["md-12"]} className="mt-2">
                <DateTimePicker
                  mode="date"
                  type="document"
                  placeholder="Examination Date"
                  customInput={true}
                  value={documents.current_examination_date}
                  onChange={val =>
                    setMedicalRecord({ current_examination_date: val })
                  }
                />
              </Col>
            </Row>
          </Card>
          {documents.medical_records
            ? documents.medical_records.map((value, index) => (
                <Card>
                  <Row className="mt-5 mb-1">
                    <Col>
                      <CardLable
                        name={"Medical Record " + (index + 1)}
                        condition={null}
                        onclick={() => removeMedicalRecord(index)}
                        labelName="Remove"
                      />
                    </Col>
                    <Col size={["md-12"]} className="mt-3 mb-1">
                      <TextInput
                        type="text"
                        label="Medical Record Name"
                        disabled={true}
                        value={value.medical_record_name}
                      />
                    </Col>
                    <Col size={["md-12"]} className="mt-1 mb-n3">
                      <TextInput
                        type="text"
                        label="Record Type"
                        disabled={true}
                        value={
                          value.record_type?.label
                            ? value.record_type?.label
                            : value.record_type
                        }
                      />
                    </Col>
                    <Col size={["md-12"]} className="mt-1 ">
                      <FileInput
                        showPreview
                        name="insuranceDoc"
                        files={value.document}
                      />
                    </Col>
                    <Col size={["md-12"]} className="mt-1 mb-5">
                      <DateTimePicker
                        mode="date"
                        type="document"
                        placeholder="Examination Date"
                        value={value.examination_date}
                        disabled={true}
                      />
                    </Col>
                  </Row>
                </Card>
              ))
            : ""}
          <Button
            type="secondary"
            indicatorButton
            className={classnames(
              "float-right next-button",
              documents.dataLoaded && "enable"
            )}
            onClick={() => {
              documents.dataLoaded && documents.dataChanged
                ? updatePatientDocuments("update", () => {
                    history.push(getOnboardingPath("/profile-complete"));
                  })
                : documents.dataChanged
                ? savePatientDocuments("save", () => {
                    history.push(getOnboardingPath("/profile-complete"));
                  })
                : history.push(getOnboardingPath("/profile-complete"));
            }}
            label={<OnboardingIcon type="nextButton" />}
          />
        </Row>
      </div>
    </>
  );
};

const mapStoreToProps = ({ onboarding, validation, auth }) => ({
  documents: onboarding.medicalRecord,
  form: validation.data,
});

const mapDispatchToProps = dispatch => ({
  setMedicalRecord: updatedData =>
    dispatch(actions.setMedicalRecord(updatedData)),
  savePatientDocuments: (action, cb) =>
    dispatch(actions.savePatientDocuments(action, cb)),
  updatePatientDocuments: (action, cb) =>
    dispatch(actions.updatePatientDocuments(action, cb)),
  deleteFileFromS3: (file, cb) => dispatch(actions.deleteFileFromS3(file, cb)),
  addMedicalRecord: () => dispatch(actions.addMedicalRecord()),
  removeMedicalRecord: index => dispatch(actions.removeMedicalRecord(index)),
  validateData: documents =>
    dispatch(actions.validateData(VALIDATE_PATIENT_DOCUMENT_INFO, documents)),
  removeValidations: () =>
    dispatch(actions.validateData(REMOVE_VALIDATIONS, {})),
});

export default withRouter(
  connect(mapStoreToProps, mapDispatchToProps)(StepTwo)
);
